import styles from './LegalPage.module.css';

export function TermsPage() {
  return (
    <div className={styles.page}>
      <h1 className={styles.heading}>Terms of Use</h1>
      <p className={styles.subheading}>Last updated: October 5, 2026</p>

      <section className={styles.section}>
        <h2>1. Who we are</h2>
        <p>
          WhaleTail is operated by Reints Labs LLC, an Iowa limited liability company
          (&ldquo;Reints Labs,&rdquo; &ldquo;we,&rdquo; &ldquo;us,&rdquo; or
          &ldquo;our&rdquo;). By accessing or using WhaleTail (the &ldquo;Site&rdquo;),
          you agree to these Terms of Use. If you do not agree, do not use the Site.
        </p>
      </section>

      <section className={styles.section}>
        <h2>2. Not financial, investment, tax, or legal advice</h2>
        <p>
          WhaleTail is an informational and educational tool only. It is{' '}
          <strong>not</strong> financial advice, investment advice, trading advice,
          betting or wagering advice, tax advice, or legal advice, and nothing on the Site
          is a recommendation, solicitation, or offer to buy, sell, or hold any asset
          (including Bitcoin), to trade any prediction-market or event contract (including
          on Kalshi), or to place any bet. Any market signal, indicator (including EMA and
          RSI values), model probability, simulated or backtested result, odds comparison,
          price-gap flag, fighter statistic, rationale, or suggested amount shown on the
          Site is an experimental calculation derived from historical or third-party data.
          Simulated and backtested results are hypothetical, do not reflect real trades,
          and do not predict future results. It can be wrong, delayed, or based on
          incomplete data. You should not rely on it, or on any other content on the Site,
          as the basis for a financial decision. Cryptocurrency is volatile and can lose
          value rapidly and entirely, and prediction-market contracts and wagers can lose
          their entire cost. Prediction markets and sports wagering may be restricted or
          illegal where you live, and age limits apply; it is your responsibility to
          follow the laws that apply to you. You are solely responsible for evaluating
          your own risk tolerance and for any financial decisions and their outcomes.
        </p>
      </section>

      <section className={styles.section}>
        <h2>3. Read-only tool; no custody, no accounts</h2>
        <p>
          WhaleTail only reads publicly available blockchain and market data for addresses
          you choose to view. It never requests, stores, or transmits private keys, seed
          phrases, wallet signatures, exchange credentials, or any other credential, and
          it never executes a trade or any other transaction on your behalf. WhaleTail
          does not require or offer user accounts.
        </p>
      </section>

      <section className={styles.section}>
        <h2>4. Third-party data</h2>
        <p>
          Wallet and transaction data is sourced from the Blockstream Esplora API. Price
          and market data is sourced from the CoinGecko API and Coinbase.
          Prediction-market prices come from Kalshi&apos;s public market data, sportsbook
          odds from The Odds API, and fighter information from Wikipedia and UFC Stats
          data. We do not control, and make no representation or warranty about the
          accuracy, completeness, availability, or timeliness of, data from these or any
          other third-party source. These services may be delayed, rate-limited, or
          unavailable at any time, and any resulting inaccuracy or unavailability on the
          Site is outside our control.
        </p>
      </section>

      <section className={styles.section}>
        <h2>5. No warranty</h2>
        <p>
          The Site and its content are provided &ldquo;as is&rdquo; and &ldquo;as
          available,&rdquo; without warranty of any kind, express or implied, including
          without limitation warranties of merchantability, fitness for a particular
          purpose, non-infringement, accuracy, or availability. We do not warrant that the
          Site will be error-free, uninterrupted, or secure.
        </p>
      </section>

      <section className={styles.section}>
        <h2>6. Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, Reints Labs LLC, its members, and its
          contributors will not be liable for any indirect, incidental, special,
          consequential, or punitive damages, or for any loss of profits, revenue, data,
          or cryptocurrency value, arising out of or related to your access to or use of,
          or inability to access or use, the Site or its content, including any financial
          decision made in reliance on anything displayed on the Site, even if we have
          been advised of the possibility of such damages. To the extent any liability is
          not excludable under applicable law, our total aggregate liability for any claim
          arising out of or relating to the Site is limited to fifty US dollars ($50).
        </p>
      </section>

      <section className={styles.section}>
        <h2>7. Assumption of risk</h2>
        <p>
          You acknowledge that cryptocurrency markets are highly volatile and speculative,
          that past performance and technical indicators do not predict future results,
          and that you assume all risk associated with any decision to acquire, hold, or
          dispose of any cryptocurrency, whether or not related to information viewed on
          the Site.
        </p>
      </section>

      <section className={styles.section}>
        <h2>8. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless Reints Labs LLC and its members from
          any claim, loss, liability, or expense (including reasonable attorneys&apos;
          fees) arising out of your use of the Site or your violation of these Terms.
        </p>
      </section>

      <section className={styles.section}>
        <h2>9. Intellectual property</h2>
        <p>
          The content, design, and branding of the Site belong to Reints Labs LLC unless
          otherwise noted. The companion Scriptable script is provided for personal,
          non-commercial use.
        </p>
      </section>

      <section className={styles.section}>
        <h2>10. Changes to the Site or these Terms</h2>
        <p>
          We may modify, suspend, or discontinue the Site, or update these Terms, at any
          time without notice. Continued use of the Site after changes constitutes
          acceptance of the updated Terms.
        </p>
      </section>

      <section className={styles.section}>
        <h2>11. Governing law</h2>
        <p>
          These Terms are governed by the laws of the State of Iowa, without regard to
          conflict of law principles, and any dispute arising out of or relating to the
          Site will be subject to the exclusive jurisdiction of the state and federal
          courts located in Iowa.
        </p>
      </section>

      <section className={styles.section}>
        <h2>12. Contact</h2>
        <p>
          Questions about these Terms can be sent to{' '}
          <a href="mailto:sales@reintslabs.com">sales@reintslabs.com</a>.
        </p>
      </section>
    </div>
  );
}
